
export const ERRORS = [
	{
		title: 'APP_ID_NOT_EXIST',
		desc: '<b>app-id</b> header is found but the value is not valid.'
	},
	{
		title: 'APP_ID_MISSING',
		desc: '<b>app-id</b> header is not set correctly. Note that you need to set <b>app-id</b> header for each request. <b>Getting Started</b> page for more info.'
	},
	{
		title: 'PARAMS_NOT_VALID',
		desc: 'URL params (ex: /user/{id} - {id} is URL param) is not valid. This error returned in both cases: param format is invalid, param is not found.'
	},
	{
		title: 'BODY_NOT_VALID',
		desc: 'Applicable only for not GET requests like POST, PUT or DELETE. Boyd format is invalid, or even some keys are not valid.'
	},
	{
		title: 'RESOURCE_NOT_FOUND',
		desc: 'Applicable for all requests that has {id} URL param. Mean that item that was requested(for get, update, delete) is not found. Works correctly if you try to create a post for user that not exist or deleted.'
	},
	{
		title: 'PATH_NOT_FOUND',
		desc: 'Request path is not valid, check controller documentation to validate the URL.'
	},
	{
		title: 'SERVER_ERROR',
		desc: 'Something is wrong with server, try again later. And/or report to our support telegram channel/email.'
	},
];
